<template>
  <div class="export-btn-box">
    <div class="export-btn" v-bind:class="{ 'disabled': complete !== true || currentJob.state === 'failed'}"  @click="dropdownActive = !dropdownActive" v-if="exportAsLinks.length > 0">
      {{ 'Export As' | trans }}
      <i class="far fa-chevron-down" v-if="!dropdownActive"></i>
      <i class="far fa-chevron-up" v-if="dropdownActive"></i>


      <div id="export-dropdown" class="" v-if="(dropdownActive && currentJob.state !== 'failed') && currentJob.state !== 'processing' && currentJob.state !== 'not_found'">

        <div  v-for="item in exportAsLinks">
          <div class="dropdown-item text-uppercase" @click="openExport(item.feature.operation)">
            {{ item.extension | trans }}
          </div>

          <div class="dropdown-divider"></div>
        </div>

        <div class="dropdown-item" @click="openMore()">
          <i class="far fa-ellipsis-h"></i> more
        </div>

      </div>
    </div>

    <div class="export-btn" v-bind:class="{ 'disabled': complete !== true || currentJob.state === 'failed'}"  @click="openMore" v-if="exportAsLinks.length === 0">
      {{ 'Export As' | trans }}
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import JobManager from "../../manager/JobManager";
import Reconvert from "../../util/Reconvert";
import {EventBus} from "../../events/event.bus";
import {EVENT_APP_NAVIGATE} from "../../events/app.events";

export default {
  name: "ExportBtn",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
  ],
  data() {
    return {
      dropdownActive: false
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openMore() {
      this.resultPage.activeToolGroup = 'converter';
      EventBus.$emit(EVENT_APP_NAVIGATE, `/${this.currentJob.id}/tools`, {})
    },
    openExport(operation) {
      if (this.complete && this.selectedOutputs.length > 0) {
        Reconvert.continueWithSelectedExport(this.currentJob, operation);
      }
    },
  },
  computed: {
    exportAsLinks() {
      if (this.currentJob.apiJob === null) {
        return [];
      }

      return Reconvert.getExportAsList(this.currentJob);
    }
  }
};
</script>
<style lang="scss" scoped>
#export-dropdown {
  position:absolute;
  background: white;
  top: 40px;
  left:0;
  border-left:2px solid #1266F1;
  border-bottom:2px solid #1266F1;
  border-right:2px solid #1266F1;
  width: 100%;
  border-radius: 0 0 9px 9px;
  overflow: hidden;
  color: #1266F1;
  font-weight: bold;
  .dropdown-item {
    padding: 10px 20px;
    color: #1266F1;
    font-weight:bold;
  }

  user-select: none;
}

.export-btn-box {
  flex: 1 1 auto;
  position:relative;
}
.export-btn-dropdown {
  height: 100%;
  align-items: center;
  display: inline-flex;
  padding: 0 30px;
  user-select: none
}
.export-btn {

  //background: #1266F1;
  border: 2px solid #1266F1;
  color: #1266F1;
  width: 100%;
  //color: white;
  height: 45px;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;


  flex: 1 0 auto;
  &:hover {
  }
}

.disabled {
  opacity: .5;
  cursor: not-allowed;
}
</style>
